module.exports = __webpack_public_path__ + "static/media/ellipsis-h.d62bb519.svg";